import { Alert, Box, Paragraph, TextButton } from '@zillow/constellation-10';
import { useAuth } from '../../../../AuthProvider';

type ErrorContainerProps = {
  hasAuthError: boolean;
};

const GENERIC_ERROR_MESSAGE = 'There was an error, please try again.';

function getSwitchAccountsHref() {
  if (typeof window === 'undefined') {
    return '/user/acct/login/';
  }
  return `/user/acct/login/?url=${encodeURIComponent(window.location.pathname + window.location.search)}`;
}

export default function ErrorContainer({ hasAuthError }: ErrorContainerProps) {
  const { user } = useAuth();
  const userEmail = user?.email;

  if (hasAuthError) {
    return (
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          padding: 'default',
        }}
      >
        <Alert
          tone="warning"
          actionButton={
            <TextButton asChild>
              <a href={getSwitchAccountsHref()}>Switch accounts</a>
            </TextButton>
          }
        >
          {userEmail ? (
            <>
              You’re signed in as {userEmail}. This email isn’t connected to this conversation. Sign in with the email
              address linked to your conversation.
            </>
          ) : (
            <>
              This email isn’t connected to this conversation. Sign in with the email address linked to your
              conversation.
            </>
          )}
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Paragraph css={{ color: 'red.400' }}>{GENERIC_ERROR_MESSAGE}</Paragraph>
    </Box>
  );
}
